export default __webpack_public_path__ + "static/jigsaw-1586944be50cc7fb17962f32a946427a.png";